// @flow
import React, {useState} from 'react';
import {TextInput, InputBase, InputInlay} from 'sail/Input';
import {Select, SelectOption} from 'sail/Select';
import {CaptionMono} from 'sail/Text';
import Button from 'sail/Button';
import Group from 'sail/Group';
import {arrayItemWidth, addRemoveButtonWidth} from './styleConstants';

type ArrayElementInputProps = {|
  field_id: string,
  param_key: string,
  elementType: Object,
  params: Object,
  setParams: (Object) => void,
|};

export const ArrayElementInput = ({
  field_id,
  param_key,
  elementType,
  params,
  setParams,
}: ArrayElementInputProps) => {
  const [value, setValue] = useState('');

  const addEntry = () => {
    if (!value) {
      return;
    }

    const {[param_key]: oldArray, ...otherParams} = params;
    if (oldArray) {
      setParams({...otherParams, [param_key]: [...oldArray, value]});
    } else {
      setParams({...otherParams, [param_key]: [value]});
    }

    setValue('');
  };

  const renderInputArea = () => {
    if (elementType.shape === 'enum') {
      return (
        <InputBase radius="none" width={arrayItemWidth}>
          <Select
            value={value}
            onChange={setValue}
            defaultValue=""
            width="maximized"
          >
            <SelectOption value="" label="" />
            {elementType.enum.map((item) => (
              <SelectOption
                key={`${param_key}-${item}`}
                value={item}
                label={`${item}`}
              />
            ))}
          </Select>
          <InputInlay buffer="horizontal">
            <CaptionMono color="gray">enum</CaptionMono>
          </InputInlay>
        </InputBase>
      );
    }
    // must be a primitive string or literal
    const inputType =
      elementType.shape === 'primitive'
        ? elementType.primitive
        : elementType.literal;

    return (
      <TextInput
        radius="none"
        key={field_id}
        id={field_id}
        onChange={setValue}
        end={{
          'aria-label': `${inputType}`,
          content: (
            <CaptionMono
              color="gray"
              wrap={false}
            >{`${inputType}`}</CaptionMono>
          ),
        }}
        value={value}
        width={arrayItemWidth}
      />
    );
  };

  return (
    <Group direction="horizontal">
      {renderInputArea()}
      <Button
        label="Add"
        onClick={addEntry}
        width={addRemoveButtonWidth}
        radius="none"
        color="blue"
      />
    </Group>
  );
};
